<template>
  <span>
    <v-card-text>
      <file-up
        :label=label
        :brief=brief
      >
      </file-up>
    </v-card-text>
    <v-card-text>
      <v-container>
        <v-progress-linear v-if="uploading"
          :active="uploading"
          indeterminate
          width="2"
        ></v-progress-linear>
      </v-container>
    </v-card-text>
    <v-card-actions>

        <v-btn color="primary"
          :disabled="uploading || !thumbData.length"
          @click="upload"
        >
          Upload
        </v-btn>
        <v-btn color="secondary"
          :disabled="uploading"
          @click="cancel"
        >
          cancel
        </v-btn>

    </v-card-actions>
  </span>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { vxMaps } from '@/js/vxstore'
import FileUp from '@/components/Fileup'
import { createArtworkUploadUrlsGql, storagePut, finalizeUploadArtworkGql, createArtworksGql } from '@/js/mutations'

export default {
  data: () => ({
    uploading: false
  }),
  props: {
    label: String,
    runId: String,
    artworkTypeId: String,
    artworkComment: String,
    brief: Boolean,
    forceOriginal: Boolean
  },
  components: {
    'file-up': FileUp
  },
  computed: {
    artworkID() {
      return this.artworkId
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters)
  },

  methods: {
    toStorage (file) {
      this.setThumb({
        property: 'status',
        value: 'upload',
        index:file.index
      })
      return storagePut(file)
        .then(r=> {
          this.setThumb({
            property: 'status',
            value: 'register',
            index:file.index
          })
          return r
        })
        .catch(error=> {
          this.setThumb({
            property: 'status',
            value: 'error',
            index:file.index
          })
          throw new Error(error)
        })
    },

    cancel () {
      this.uploading = false
      this.$emit('cancel')
    },

    upload () {
      this.uploading = true
      return createArtworkUploadUrlsGql({ apolloClient: this.$apollo, files: this.thumbData})
        .then(r=> Promise.all([
          Promise.all(r.map(f=>this.toStorage(f).then(()=>f))),
          createArtworksGql ({
            files: r,
            apolloClient: this.$apollo,
            artworkTypeID: this.artworkTypeId,
            runID: this.runId,
            comment: this.artworkComment
          })
        ]))
        .then(all => {
          const [urls,arts] = all
          return Promise.all(
            this.thumbData.map(file =>
              finalizeUploadArtworkGql({
                apolloClient: this.$apollo,
                input:{
                  artworkID: arts[file.index].id,
                  // this is important as it identifies an original type file for downloading
                  original: this.forceOriginal || Boolean(file.original),
                  widthPx: (file.dimensions && file.dimensions.width) || null,
                  heightPx: (file.dimensions && file.dimensions.height) || null,
                  targetName: null,
                  runID: this.runId
                },
                uploadID: urls[file.index].uploadUrl.uploadID,
                customName: (file.retain && file.file.name) || null
              })
              .then(r=>{
                this.setThumb({
                  property: 'artworkID',
                  value: r.artworkID,
                  index:file.index
                })
                this.setThumb({
                  property: 'signedUrl',
                  value: r.ArtworkArtifact.SignedUrl.url,
                  index:file.index
                })
                this.setThumb({
                  property: 'status',
                  value: 'done',
                  index: file.index
                })
                return r
              })
          ))
          .then(r => {
            this.uploading = false
            this.$emit('done', { files: this.thumbData })
            return r;
          })
          .catch(error =>{
            console.error(error)
            this.uploading = false
            this.$emit('error', { error })
          })
        })
    },
    ...mapMutations(vxMaps.mutations),
    ...mapActions(vxMaps.actions)
  }
}
</script>
